export default __webpack_public_path__ + "static/media/pinterest-icon.e38f3012.png";